const zhHKMessages = {
  "chat.end": "重新開始您的聊天對話",
  "chat.cancel": "取消",
  "chat.endall": "結束聊天",
  "chat.cookie": "此數字助理使用 cookie 來確保您獲得最佳體驗",
  "chat.learn": "了解更多",
  "chat.minimize": "最小化",
  "chat.hide": "關",
  "chat.hidebot.text": "關閉將使頭像消失 15 分鐘",
  "chat.hidebot": "關閉機器人",
  "chat.restart": "重新開始",
  "switch.language": "切換語言",
  "switch.property": "開關屬性",
  "restart.converstation": "重啟轉換",
  "chat.endtext": "您確定要結束當前聊天嗎？",
  "check.availabity": "檢查可用性",
  "check.availabity.submit": "提交",
  "check.availabity.cancel": "取消",
  "check.availabity.adults": "成年人 ",
  "check.availabity.children": "孩子們",
  "check.availabity.child.age": "年齡 - 兒童",
  "feedback.leave": "留下反馈信息",
  "feedback.leave.message": "請留言",
  "placeholder.name": "Name",
  "placeholder.firstName": "名字",
  "placeholder.lastName": "姓氏",
  "placeholder.email": " 電子信箱",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode": "Zip Code",
  "caseform.title": "提交案件",
  "caseform.system": "系統",
  "caseform.loading.systems": "正在載入系統...",
  "caseform.select.system": "選擇系統",
  "caseform.error.systems": "載入系統時出錯",
  "caseform.scenario": "情境",
  "caseform.loading.scenarios": "正在載入情境...",
  "caseform.select.scenario": "選擇情境",
  "caseform.error.scenarios": "載入情境時出錯",
  "caseform.topic": "主題",
  "caseform.loading.topics": "正在載入主題...",
  "caseform.select.topic": "選擇主題",
  "caseform.error.topics": "載入主題時出錯",
  "caseform.subject": "主旨",
  "caseform.description": "描述",
  "caseform.submit": "提交",
  "caseform.cancel": "取消",
  "caseform.success.title": "案件已建立",
  "caseform.success.message": "您的案件已成功建立。",
  "caseform.success.caseNumber": "案件編號：",
  "caseform.success.ok": "確定",
  "simpleaction.title": "選擇一個動作",
  "simpleaction.body":
    "請選擇以下選項之一：{br}{b}建立案件{/b}以提交支援請求，或 {b}開始聊天{/b} 立即與代理連接。",
  "simpleaction.startchat": "開始聊天",
  "simpleaction.createcase": "建立案件",
  "caseform.error.generic": "案件建立時發生錯誤。",
  "caseform.error.generic.message": "建立您的案件時發生錯誤。請稍後再試。",
};
export default zhHKMessages;
